import vuex from 'vuex';
import { vueUse } from './utils/vuePlugins';
import camelCase from 'lodash/camelCase';
export let moduleName = 'd2Auth';
export const D2Vuex = {
    install(Vue, options) {
        Vue.use(vuex);
    }
};
vueUse(D2Vuex);
export function setupD2Vuex(contextModules) {
    const modules = {};
    contextModules.keys().forEach(fileName => {
        if (fileName === './index.js') {
            return;
        }
        const moduleName = camelCase(fileName.replace(/(\.\/|\.(js|ts))/g, ''));
        modules[moduleName] = contextModules(fileName).default;
    });
    return new vuex.Store({
        strict: process.env.NODE_ENV !== 'production',
        modules: {
            ...modules
        }
    });
}
export function setupD2Auth(store, options) {
    moduleName = (options || {}).moduleName || moduleName;
    store.registerModule(moduleName, {
        namespaced: true,
        state: {
            company: null,
            loggedIn: false,
            profile: null,
            roles: [],
            claims: []
        },
        getters: {
            [GetterNames.PROFILE]: state => state.profile,
            [GetterNames.LOGGED_IN]: state => state.loggedIn,
            [GetterNames.ROLES]: state => state.roles,
            [GetterNames.CLAIMS]: state => state.claims,
            [GetterNames.COMPANY]: state => state.company,
            [GetterNames.HAS_ROLE]: state => (role) => state.roles.includes(role),
            [GetterNames.HAS_CLAIM]: state => (claim) => state.claims.includes(claim),
            [GetterNames.HAS_ALL_ROLES]: state => (roles) => roles.every(role => state.roles.includes(role)),
            [GetterNames.HAS_ALL_CLAIMS]: state => (claims) => claims.every(claim => state.claims.includes(claim)),
            [GetterNames.HAS_ANY_ROLE]: state => (roles) => !!roles.find(role => state.roles.includes(role)),
            [GetterNames.HAS_ANY_CLAIM]: state => (claims) => !!claims.find(claim => state.claims.includes(claim))
        },
        mutations: {
            UPDATE_COMPANY(_state, company) {
                _state.company = company;
            },
            SET_AUTHENTICATED(_state, value) {
                _state.loggedIn = value;
            },
            UPDATE_PROFILE(_state, profile) {
                _state.profile = profile;
            },
            UPDATE_ROLES(_state, roles) {
                _state.roles = roles;
            },
            UPDATE_CLAIMS(_state, claims) {
                _state.claims = claims;
            },
            UPDATE_LOGGED_IN_STATUS(_state, status) {
                _state.loggedIn = status;
            }
        },
        actions: {
            [ActionNames.SET_CURRENT_COMPANY]({ commit }, payload) {
                commit('UPDATE_COMPANY', payload);
            },
            [ActionNames.SET_ROLES]({ commit }, payload) {
                commit('UPDATE_ROLES', payload);
            },
            [ActionNames.SET_AUTHENTICATED]({ commit }, payload) {
                commit('SET_AUTHENTICATED', payload);
            },
            [ActionNames.SET_CLAIMS]({ commit }, payload) {
                commit('UPDATE_CLAIMS', payload);
            },
            [ActionNames.SET_USER_PROFILE]({ commit }, payload) {
                commit('UPDATE_PROFILE', payload);
                if (payload) {
                    commit('UPDATE_LOGGED_IN_STATUS', true);
                }
            }
        }
    });
}
export const ActionNames = Object.freeze({
    SET_CURRENT_COMPANY: 'setCurrentCompany',
    SET_USER_PROFILE: 'setUserProfile',
    SET_AUTHENTICATED: 'setAuthenticated',
    SET_ROLES: 'setRoles',
    SET_CLAIMS: 'setClaims'
});
export const GetterNames = Object.freeze({
    PROFILE: 'profile',
    LOGGED_IN: 'loggedIn',
    ROLES: 'roles',
    CLAIMS: 'claims',
    COMPANY: 'company',
    HAS_ROLE: 'hasRole',
    HAS_ALL_ROLES: 'hasAllRoles',
    HAS_ANY_ROLE: 'hasAnyRole',
    HAS_CLAIM: 'hasClaim',
    HAS_ALL_CLAIMS: 'hasAllClaims',
    HAS_ANY_CLAIM: 'hasAnyClaim'
});
export const NamespacedActionNames = Object.assign({}, ...Object.keys(ActionNames).map(key => ({ [key]: `${moduleName}/${ActionNames[key]}` })));
export const NamespacedGetterNames = Object.assign({}, ...Object.keys(GetterNames).map(key => ({ [key]: `${moduleName}/${GetterNames[key]}` })));
//# sourceMappingURL=index.js.map